module.exports = __webpack_public_path__ + "static/media/img-bg1.ea76fb6a.png";